var _rect, _rect2, _rect3, _g, _g2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProPackLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 162,
    height: 36,
    viewBox: "0 0 162 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 10.2857,
    width: 20.5714,
    height: 20.5714,
    rx: 2,
    fill: "url(#paint0_linear_157_443)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 15.4286,
    width: 30.8571,
    height: 30.8571,
    rx: 2,
    fill: "url(#paint1_linear_157_443)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 15.4286,
    width: 30.8571,
    height: 30.8571,
    rx: 2,
    fill: "#D5E6FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_157_443)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.8571 18.4286L15.4286 30.8571V0H30.8571V18.4286Z",
    fill: "url(#paint2_linear_157_443)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8571 18.4286L15.4286 30.8571V0H30.8571V18.4286Z",
    fill: "url(#paint3_linear_157_443)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8571 18.4286L46.2857 30.8571V0H30.8571V18.4286Z",
    fill: "url(#paint4_linear_157_443)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8571 18.4286L46.2857 30.8571V0H30.8571V18.4286Z",
    fill: "url(#paint5_linear_157_443)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8571 18.4286L46.2857 30.8571H15.4286L30.8571 18.4286Z",
    fill: "url(#paint6_linear_157_443)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8571 18.4286L46.2857 30.8571H15.4286L30.8571 18.4286Z",
    fill: "url(#paint7_linear_157_443)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8571 18.4286L46.2857 30.8571H15.4286L30.8571 18.4286Z",
    fill: "url(#paint8_linear_157_443)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_157_443)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5763 30.8571H17.4286C16.324 30.8571 15.4286 29.9617 15.4286 28.8571V10.2857H18.5714C19.676 10.2857 20.5714 11.1811 20.5714 12.2857V28.8571C20.5714 29.9601 19.6786 30.8545 18.5763 30.8571Z",
    fill: "url(#paint9_linear_157_443)",
    fillOpacity: 0.5
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M159.946 24.8555H161.738V30.8589H160.603V26.1365L159.113 30.8589H157.844L156.308 26.1198V30.8589H155.177V24.8555H156.978L158.485 29.5653L159.946 24.8555Z",
    fill: "#88919A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M147.841 27.8572C147.824 25.9649 149.047 24.7508 150.755 24.7717C152.463 24.7508 153.694 25.9649 153.673 27.8572C153.694 29.7495 152.463 30.9635 150.755 30.9426C149.047 30.9635 147.824 29.7495 147.841 27.8572ZM150.713 29.9169H150.801C151.868 29.9169 152.513 29.1382 152.513 27.8572C152.513 26.5719 151.868 25.8016 150.801 25.8016H150.713C149.645 25.8016 149.001 26.5719 149.001 27.8572C149.001 29.1382 149.645 29.9169 150.713 29.9169Z",
    fill: "#88919A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M141.325 27.8572C141.313 26.0151 142.389 24.755 144.197 24.7717C145.734 24.755 146.646 25.6844 146.717 26.8273H145.562C145.432 26.1742 144.963 25.8016 144.239 25.8016H144.155C143.171 25.789 142.472 26.5928 142.485 27.8572C142.485 29.1257 143.163 29.9169 144.155 29.9169H144.239C144.972 29.9169 145.432 29.5569 145.562 28.887H146.717C146.642 30.076 145.742 30.9552 144.197 30.9426C142.389 30.9594 141.313 29.6992 141.325 27.8572Z",
    fill: "#88919A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M138.925 30.8589V29.6155H140.168V30.8589H138.925Z",
    fill: "#88919A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M137.952 30.8589H136.587L135.189 28.7531L133.765 30.8589H132.463L134.54 27.7818L132.593 24.8555H133.954L135.226 26.7687L136.52 24.8555H137.822L135.875 27.7399L137.952 30.8589Z",
    fill: "#88919A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M127.061 30.8589V24.8555H131.603V25.8853H128.216V27.2669H131.088V28.2967H128.216V29.829H131.691V30.8589H127.061Z",
    fill: "#88919A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M119.725 27.8572C119.708 25.9649 120.93 24.7508 122.638 24.7717C124.346 24.7508 125.577 25.9649 125.556 27.8572C125.577 29.7495 124.346 30.9635 122.638 30.9426C120.93 30.9635 119.708 29.7495 119.725 27.8572ZM122.596 29.9169H122.684C123.752 29.9169 124.397 29.1382 124.397 27.8572C124.397 26.5719 123.752 25.8016 122.684 25.8016H122.596C121.529 25.8016 120.884 26.5719 120.884 27.8572C120.884 29.1382 121.529 29.9169 122.596 29.9169Z",
    fill: "#88919A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M116.428 24.8555H118.22V30.8589H117.085V26.1365L115.595 30.8589H114.326L112.79 26.1198V30.8589H111.66V24.8555H113.46L114.967 29.5653L116.428 24.8555Z",
    fill: "#88919A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M108.748 30.8589V29.6155H109.992V30.8589H108.748Z",
    fill: "#88919A"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M103.677 30.8589V24.8555H106.377C107.545 24.8555 108.307 25.5546 108.307 26.7436C108.307 27.9325 107.545 28.64 106.377 28.64H104.832V30.8589H103.677ZM104.832 27.6102H106.247C106.833 27.6102 107.147 27.2752 107.147 26.7436C107.147 26.2119 106.833 25.8853 106.247 25.8853H104.832V27.6102Z",
    fill: "#88919A"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M96.3405 27.8572C96.3237 25.9649 97.5462 24.7508 99.2543 24.7717C100.962 24.7508 102.193 25.9649 102.172 27.8572C102.193 29.7495 100.962 30.9635 99.2543 30.9426C97.5462 30.9635 96.3237 29.7495 96.3405 27.8572ZM99.2124 29.9169H99.3003C100.368 29.9169 101.013 29.1382 101.013 27.8572C101.013 26.5719 100.368 25.8016 99.3003 25.8016H99.2124C98.1448 25.8016 97.5001 26.5719 97.5001 27.8572C97.5001 29.1382 98.1448 29.9169 99.2124 29.9169Z",
    fill: "#88919A"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M89.9083 30.8589V24.8555H91.0638V27.3422H93.6804V24.8555H94.84V30.8589H93.6804V28.3721H91.0638V30.8589H89.9083Z",
    fill: "#88919A"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M83.5892 28.8452H84.7489C84.7908 29.4606 85.2429 29.9169 86.1221 29.9169H86.2058C86.8338 29.9169 87.1854 29.5862 87.1854 29.1885C87.1854 28.8242 87.0222 28.6317 86.5072 28.527L85.4355 28.3051C84.3847 28.0832 83.8907 27.4888 83.8907 26.5719C83.8739 25.6593 84.7447 24.755 86.1639 24.7717C87.5873 24.7592 88.4498 25.6048 88.4372 26.7436H87.2775C87.2399 26.1365 86.8003 25.8016 86.1639 25.8016H86.076C85.4522 25.8016 85.0503 26.1407 85.0503 26.53C85.0503 26.9194 85.2596 27.1036 85.7788 27.2083L86.6789 27.3883C87.7464 27.6018 88.3409 28.1586 88.3409 29.1006C88.3535 30.1304 87.4743 30.9552 86.0341 30.9426C84.4182 30.9426 83.6395 30.1137 83.5892 28.8452Z",
    fill: "#88919A"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M81.7371 30.8589L81.1971 29.4438H78.6768L78.1367 30.8589H76.9185L79.2922 24.8555H80.6486L82.9638 30.8589H81.7371ZM79.0661 28.414H80.8035L79.9327 26.1365L79.0661 28.414Z",
    fill: "#88919A"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M73.7853 30.8589V25.8853H71.713V24.8555H77.0298V25.8853H74.945V30.8589H73.7853Z",
    fill: "#88919A"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M70.5642 30.8589L70.0241 29.4438H67.5039L66.9638 30.8589H65.7455L68.1193 24.8555H69.4757L71.7908 30.8589H70.5642ZM67.8932 28.414H69.6306L68.7598 26.1365L67.8932 28.414Z",
    fill: "#88919A"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M60 30.8589V24.8554H62.0556C63.8683 24.8471 65.1117 25.923 65.0992 27.8572C65.1117 29.7955 63.906 30.8714 62.1016 30.8589H60ZM61.1555 29.829H61.9718C62.5956 29.829 63.0813 29.6783 63.4246 29.3769C63.772 29.0754 63.9437 28.5689 63.9437 27.8572C63.9437 27.1496 63.772 26.6431 63.4246 26.3417C63.0813 26.036 62.5956 25.8853 61.9718 25.8853H61.1555V29.829Z",
    fill: "#88919A"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M153.539 19.0486L149.408 13.0141L147.6 14.9172V19.0486H144.961V5.33473H147.6V11.4935L153.424 5.33473H156.695L151.292 11.0249L156.81 19.0486H153.539Z",
    fill: "#18191B"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M130.291 12.1916C130.262 7.98377 132.72 5.10521 136.851 5.14346C140.361 5.10521 142.446 7.22827 142.608 9.83906H139.969C139.672 8.34718 138.601 7.49604 136.947 7.49604H136.755C134.508 7.46735 132.911 9.30351 132.94 12.1916C132.94 15.0893 134.489 16.8968 136.755 16.8968H136.947C138.62 16.8968 139.672 16.0744 139.969 14.5442H142.608C142.436 17.2602 140.38 19.2685 136.851 19.2398C132.72 19.2781 130.262 16.3995 130.291 12.1916Z",
    fill: "#18191B"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M126.934 19.0486L125.7 15.8161H119.943L118.709 19.0486H115.926L121.349 5.33473H124.447L129.736 19.0486H126.934ZM120.832 13.4636H124.801L122.812 8.26111L120.832 13.4636Z",
    fill: "#18191B"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M105.77 19.0486V5.33473H111.938C114.607 5.33473 116.347 6.93181 116.347 9.64779C116.347 12.3638 114.607 13.98 111.938 13.98H108.41V19.0486H105.77ZM108.41 11.6274H111.642C112.981 11.6274 113.698 10.8623 113.698 9.64779C113.698 8.43325 112.981 7.68731 111.642 7.68731H108.41V11.6274Z",
    fill: "#18191B"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M85.4002 12.1916C85.362 7.86901 88.1545 5.09564 92.0563 5.14346C95.9581 5.09564 98.7698 7.86901 98.722 12.1916C98.7698 16.5143 95.9581 19.2876 92.0563 19.2398C88.1545 19.2876 85.362 16.5143 85.4002 12.1916ZM91.9607 16.8968H92.1615C94.6002 16.8968 96.0729 15.118 96.0729 12.1916C96.0729 9.2557 94.6002 7.49604 92.1615 7.49604H91.9607C89.522 7.49604 88.0493 9.2557 88.0493 12.1916C88.0493 15.118 89.522 16.8968 91.9607 16.8968Z",
    fill: "#18191B"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M72.7766 19.0486V5.33473H79.1458C81.441 5.30604 83.4015 6.95093 83.3537 9.06443C83.3537 10.8145 82.5886 11.943 81.0202 12.5264C82.4452 12.5264 83.1528 13.1767 83.1528 14.4677V19.0486H80.5134V15.1276C80.5134 14.1426 80.2265 13.8557 79.2414 13.8557H75.4161V19.0486H72.7766ZM75.4161 11.5509H78.3616C79.9013 11.5509 80.7046 10.8623 80.7046 9.57129C80.7046 8.30893 79.93 7.68731 78.3616 7.68731H75.4161V11.5509Z",
    fill: "#18191B"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M60 19.0486V5.33473H66.1684C68.8365 5.33473 70.5771 6.93181 70.5771 9.64779C70.5771 12.3638 68.8365 13.98 66.1684 13.98H62.6395V19.0486H60ZM62.6395 11.6274H65.8719C67.2108 11.6274 67.928 10.8623 67.928 9.64779C67.928 8.43325 67.2108 7.68731 65.8719 7.68731H62.6395V11.6274Z",
    fill: "#18191B"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_157_443",
    x1: 10.2857,
    y1: 10.2857,
    x2: 10.2857,
    y2: 30.8571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_157_443",
    x1: 30.8571,
    y1: 0,
    x2: 30.8571,
    y2: 30.8571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_157_443",
    x1: 23.1428,
    y1: 0,
    x2: 23.1428,
    y2: 30.8571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_157_443",
    x1: 23.1428,
    y1: 0,
    x2: 23.1428,
    y2: 30.8571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AFC1D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5D4E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_157_443",
    x1: 38.5714,
    y1: 0,
    x2: 38.5714,
    y2: 30.8571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_157_443",
    x1: 38.5714,
    y1: 0,
    x2: 38.5714,
    y2: 30.8571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2E0F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_157_443",
    x1: 30.8571,
    y1: 20.1428,
    x2: 30.8571,
    y2: 30.8571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_157_443",
    x1: 30.8571,
    y1: 20.1428,
    x2: 30.8571,
    y2: 30.8571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AFC1D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5D4E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_157_443",
    x1: 30.8571,
    y1: 20.1428,
    x2: 30.8571,
    y2: 30.8571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A3139"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#565E67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_157_443",
    x1: 30.8571,
    y1: 10.2857,
    x2: 30.8571,
    y2: 30.8571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF500"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_157_443"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.4286,
    width: 30.8571,
    height: 30.8571,
    rx: 2,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_157_443"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.4286,
    width: 30.8571,
    height: 30.8571,
    rx: 2,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProPackLogo);
export default __webpack_public_path__ + "static/media/ProPackLogo.db565c5e602a6132db7d1ea7e68f8721.svg";
export { ForwardRef as ReactComponent };